module.exports = __webpack_public_path__ + "media/send_msg.5b046232.wav";